
<div :data-component-name="$options.name">
  <b-link
    v-bind="jel_getLienBinding(content.lien)"
    :ga-img-name="imageName"
    class="sans_underline row"
  >
    <b-col
      :class="content.cssColImage ? content.cssColImage + ' overflow-clip' : 'col-6 col-md-12'"
    >
      <img
        v-lazy="jel_getFichierSrc(content.image)"
        class="w-100 drop-shadow a-decouvrir"
        :data-tag="`${jel_getNomRouteCourante()} ${content.surTitre} - ${content.titre.replace(
          /&nbsp;/g,
          ' '
        )} - ${content.dataTag}`"
        :alt="content.image['@name']"
      />
    </b-col>
    <b-col
      :class="content.cssColTextes ? content.cssColTextes : 'col-6 col-md-12 ad-center-vert'"
    >
      <p class="mb-0 pt-md-1 ad-surtitre" v-html="content.surTitre"></p>
      <p class="graphik_medium ad-titre" :class="content.cssTitre">
        <span v-html="content.titre"></span>
      </p>
      <p :class="content.cssSousTitre" v-html="content.sousTitre"></p>
      <div class="h-50" v-html="content.texte"></div>
    </b-col>
  </b-link>
</div>
